<svg:text
  [attr.x]="location[0]"
  [attr.y]="location[1]"
  [style.stroke-width]="strokeWidth$ | async"
>
  {{ text }}
</svg:text>
